import React from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";
import { Link } from "react-router-dom";

const useStyles = createUseStyles(theme => ({
  button: {
    display: "block",
    padding: "10px 20px",
    width: "100%",
    "max-width": "200px",
    color: theme.textColor,
    "text-decoration": "none",
    "font-weight": "700",
    "font-size": "20px",
    cursor: "pointer",
    "box-sizing": "border-box",
    border: 0,
    "background-color": theme.colorPrimary,
    "border-radius": theme.borderRadius,
    "text-align": "center",
    "transition-property": "background-color",
    "transition-duration": theme.transitionDuration,
    "font-family": theme.fontFamily,
    margin: "20px 0 0",
    "&:hover": {
      "background-color": "#6ed5df",
    },
  },
  green: {
    "background-color": theme.colorAlternative,
  },
  small: {
    width: "auto",
  },
  disabled: {
    opacity: 0.5,
  },
}));

const Button = ({
  children,
  color,
  size,
  to,
  type,
  disabled,
  className,
  onClick,
}) => {
  const classes = useStyles();

  const cn = clsx(
    classes.button,
    {
      [classes.green]: color === "green",
      [classes.small]: size === "small",
      [classes.disabled]: disabled === true,
    },
    className,
  );

  if (!disabled && type === "submit") {
    return <button className={cn}>{children}</button>;
  }

  if (!disabled && to !== undefined) {
    return (
      <Link className={cn} to={to}>
        {children}
      </Link>
    );
  }

  let onClickFunction = undefined;
  if (disabled !== true) {
    onClickFunction = onClick;
  }

  return (
    <div onClick={onClickFunction} className={cn}>
      {children}
    </div>
  );
};

export default Button;
